/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Advanced_Options_LabelInputs */

const en_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced Options`)
};

const fr_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Options avancées`)
};

const de_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte Optionen`)
};

const it_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opzioni avanzate`)
};

const ru_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширенные параметры`)
};

const es_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

const zh_cn2_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级选项`)
};

const ja_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細オプション`)
};

const hi_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन्नत विकल्प`)
};

const pt_pt2_dialogue_list_export_advanced_options_label = /** @type {(inputs: Dialogue_List_Export_Advanced_Options_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opções avançadas`)
};

/**
* | output |
* | --- |
* | "Advanced Options" |
*
* @param {Dialogue_List_Export_Advanced_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_advanced_options_label = /** @type {((inputs?: Dialogue_List_Export_Advanced_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Advanced_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "de") return de_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "it") return it_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "ru") return ru_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "es") return es_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "ja") return ja_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "hi") return hi_dialogue_list_export_advanced_options_label(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_advanced_options_label(inputs)
	return en_dialogue_list_export_advanced_options_label(inputs)
});